<template>
  <div class="flow-confirmation text-center">
    <img :src="logoMark" alt="HiiKER" class="flow-confirmation__logo mb-4" />
    <h2 class="h3 mb-3"><b>{{ title }}</b></h2>
    <p class="flow-confirmation__body mb-4">
      {{ bodyPrefix }}<b v-if="bold">{{ bold }}</b>{{ bodySuffix }}
    </p>
    <button type="button" class="btn btn-primary px-5" @click="$emit('continue')">{{ $t('shared.continue') }}</button>
  </div>
</template>

<script setup lang="ts">
import logoMark from "../../../images/PROPLUS-thumbnail.webp";

defineProps<{
  title: string;
  bodyPrefix?: string;
  bold?: string;
  bodySuffix?: string;
}>();
defineEmits<{ (e: "continue"): void }>();
</script>

<style scoped lang="scss">
.flow-confirmation {
  max-width: 460px;
  margin: 2rem auto;

  &__logo {
    width: 88px;
    height: 88px;
    border-radius: 20px;
    object-fit: cover;
  }

  &__body {
    font-size: 1.05rem;
  }
}
</style>
